import React, { useCallback, useEffect, useState } from "react";
import get from "lodash.get";
import dynamic from "next/dynamic";
import { CustomizableTicker } from "@bloomberg/media-ui-markets";
import { useAbba } from "@foundation/abba-client";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { useScreen } from "@foundation/screen";

import { BRANDS } from "~constants";
import MostReadComponent from "~components/MostRead";
import isEnabled from "~utils/features";

import styles from "./rightRail.module.css";

const REGISTRATION_BASE_URL =
    process.env.NEXT_PUBLIC_REGISTRATION_URL || "https://login.bloomberg.com";
const USER_API_URL = `${REGISTRATION_BASE_URL}/user-api/graphql`;
const TICKERLIST_URL = process.env.NEXT_PUBLIC_TICKERLIST_URL || "";
const SEARCH_CLIENT_URL = process.env.NEXT_PUBLIC_SEARCH_CLIENT_URL || "";

const IS_CUSTOMIZABLE_TICKER_ENABLED = isEnabled("enableCustomizableTicker");

const PopularInOpinionComponent = dynamic(
    () => import("~components/PopularInOpinion")
);

export const TickerAndMostRead = ({
    brand,
}: {
    brand: string;
    criteria: () => boolean;
}) => {
    const { client } = useRegUIClient();
    const [regUIClient, setRegUIClient] = useState(client);

    const abbaConfig = useAbba().abbaConfig;
    const useMostRead = get(abbaConfig, ["customized-ticker", "useMostRead"]);

    useEffect(() => {
        setRegUIClient(client);
    }, [client]);

    const {
        breakpoints: { smallDesktop },
    } = useScreen();

    const trackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            window?.dataLayer?.push({
                event: "markets-at-a-glance-click",
                eventCategory: "markets-at-a-glance-engagement",
                eventAction,
                eventLabel,
            });
        },
        []
    );

    const isOpinion = BRANDS.OPINION === brand || BRANDS.VIEW === brand;

    return (
        <div className="bottomSectionTmp">
            <div className={styles.customizableTicker}>
                {!useMostRead &&
                    IS_CUSTOMIZABLE_TICKER_ENABLED &&
                    regUIClient && (
                        <CustomizableTicker
                            userApiURL={USER_API_URL}
                            tickerDataDomain={TICKERLIST_URL}
                            mediaServicesSearchURL={SEARCH_CLIENT_URL}
                            regUIClient={regUIClient as any}
                            trackingFunction={trackingFunction}
                        />
                    )}
                {!isOpinion && useMostRead && (
                    <MostReadComponent brand={brand} />
                )}
                {isOpinion && useMostRead && smallDesktop && (
                    <PopularInOpinionComponent brand={brand} />
                )}
            </div>
        </div>
    );
};
